import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	termination: [],
	terminationReason: null,
	error: "",
	loading: false,
};

// ADD_terminationReason
export const addTerminationReason = createAsyncThunk(
	"terminationReason/addTerminationReason",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `terminationReason`,
				data: {
					...values,
				},
			});
			toast.success("Termination Reason added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Termination Reason try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_terminationReason
export const deleteTerminationReason = createAsyncThunk(
	"terminationReason/deleteTerminationReason ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `terminationReason/${id}`,
			});

			toast.success("Termination Reason deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Termination Reason try again");
			// console.log(error.message);
		}
	}
);


// terminationReason
export const getAllTerminationReason = createAsyncThunk(
	"terminationReason/getAllTerminationReason",
	async () => {
		try {
			const { data } = await axios.get(`terminationReason`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const updateTerminationReason = createAsyncThunk(
	"terminationReason/updateTerminationReason",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `terminationReason/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Termination Reason updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Termination Reason try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const terminationReasonSlice = createSlice({
	name: "terminationReason",
	initialState,
	reducers: {
		clearTerminationReason: (state) => {
			state.terminationReason = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllTerminationReason ======

		builder.addCase(getAllTerminationReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllTerminationReason.fulfilled, (state, action) => {
			state.loading = false;
			state.termination = action.payload;
		});

		builder.addCase(getAllTerminationReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addTerminationReason  ======

		builder.addCase(addTerminationReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addTerminationReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addTerminationReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updateTerminationReason ======

		builder.addCase(updateTerminationReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateTerminationReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateTerminationReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteTerminationReason  ======

		builder.addCase(deleteTerminationReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteTerminationReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteTerminationReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default terminationReasonSlice.reducer;
export const { clearTerminationReason } = terminationReasonSlice.actions;
